import { Avatar, Popconfirm, Tag, message } from "antd";
import moment from "moment";
import * as React from "react";
import SVG from "react-inlinesvg";
// import { request } from 'src/utils/services';
import { useMutation, useQuery } from "react-query";
import type { ColumnsType } from "antd/lib/table";
import { Datatable } from "../../../../components/Datatable";
//import GrManageModal from "../../Modal/ManageGr";
import { getGr, getGrById, getGrGST } from "../../Requests";
//import { getInstrumentById } from 'src/modules/Instruments/Requests';
import LocalStorageService from "src/utils/local-storage";
import CookiesService from "src/utils/cookie";
import { Button, Tooltip, Space, Input, Table } from "antd";
import { ColumnType, FilterConfirmProps } from "antd/lib/table/interface";
import Highlighter from "react-highlight-words";
import type { InputRef } from 'antd';
//import GrViewModal from "../../Modal/ShowGrDetails";
import {
  EyeOutlined,
  EditOutlined,
  DownloadOutlined,
  SearchOutlined,
  DeleteOutlined,
  // CloseOutlined,
  // CheckOutlined,
} from "@ant-design/icons";
import { isMobile } from "react-device-detect";
import { queryClient } from "src";
import { request } from "src/utils/services";

interface DataType {
  key: React.Key;
  id: number;
  challanNo: any;
  privateMark: any;
  grNumber: any;
  lorryNo: any;
  content: any;
}

type DataIndex = keyof DataType;

const GrList: React.FC = () => {
  const [page, setPage] = React.useState(1);
  const [size, setSize] = React.useState(100);
  const [searchText, setSearchText] = React.useState("");
  const [searchedColumn, setSearchedColumn] = React.useState("");
  const searchInput = React.useRef<InputRef>(null);
  // console.log(CookiesService.getToken(), "token")
  const DeleteGrMutation = useMutation(
    (id: number) =>
      request(
        "user.gr.delete",
        { id: id },
        {
          isDeleted: true,
          deletedAt: moment().format("YYYY-MM-DD hh:mm:ss"),
        }
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("gr");
        queryClient.invalidateQueries("grforgatepass");
      },
    }
  );
  const {
    isLoading,
    isError,
    data: response,
  } = useQuery(
    ["gr", LocalStorageService.getAccount().id, page, size],
    () =>
      LocalStorageService.getRoles() === "ROLE_MODERATOR"
        ? getGrGST()
        : getGr(),
    {
      refetchOnWindowFocus: false,
      // enabled: false,
      keepPreviousData: true,
      staleTime: 5000,
      // refetchOnMount: false,
    }
  );

  if (isLoading || isError) {
    return <div>Loading</div>;
  }
  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button> */}
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const column: ColumnsType<DataType> = isMobile
    ? [
        {
          title: "GR No.",
          dataIndex: "grNumber",
          key: "grNumber",
          ...getColumnSearchProps("grNumber"),
          width: "20vw",
          fixed: "left",
        },
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          render: (text: any) => moment(text).format("D MMM y"),
          width: "100px",
          defaultSortOrder: "descend",
          sorter: (a: { id: number }, b: { id: number }) => a.id - b.id,
        },
        {
          title: "Challan No.",
          dataIndex: "challanNo",
          key: "challanNo",
          ...getColumnSearchProps("challanNo"),
          width: "125px",
          ellipsis: {
            showTitle: false,
          },
          render: (address) => (
            <Tooltip placement="topLeft" title={address}>
              {address}
            </Tooltip>
          ),
        },
        {
          title: "No. Of Pkgs",
          dataIndex: "quantity",
          key: "quantity",
          width: "80px",
        },
        {
          title: "Weight",
          dataIndex: "weight",
          key: "weight",
          width: "80px",
        },

        {
          title: "Contains",
          dataIndex: "content",
          key: "content",
          ...getColumnSearchProps("content"),
          width: "100px",
          ellipsis: {
            showTitle: false,
          },

          render: (address) => (
            <Tooltip placement="topLeft" title={address}>
              {address}
            </Tooltip>
          ),
        },
        {
          title: "Paid Amount",
          dataIndex: "paidAmount",
          key: "paidAmount",
          width: "100px",
        },
        {
          title: "To Pay Amount",
          dataIndex: "toPayAmount",
          key: "toPayAmount",
          width: "100px",
        },

        {
          title: "Private Mark",
          dataIndex: "privateMark",
          key: "privateMark",
          width: "100px",
          ...getColumnSearchProps("privateMark"),
          ellipsis: {
            showTitle: false,
          },
          render: (address) => (
            <Tooltip placement="topLeft" title={address}>
              {address}
            </Tooltip>
          ),
        },
        {
          title: "Status",
          dataIndex: "grStatus",
          key: "grStatus",
          width: "25vw",
          fixed: "right",
          render: (text: any) =>
            text === "Intransit" ? (
              <Tag color="#f50">{text}</Tag>
            ) : text === "At Warehouse" ? (
              <Tag color="#F502e9">
                {text}
                {/* <h1>{text}</h1> */}
              </Tag>
            ) : text === "Partial Dispatch" ? (
              <Tag color="#e6b800">{text}</Tag>
            ) : (
              <Tag color="#004d00">
                {text}
                {/* <h1>{text}</h1> */}
              </Tag>
            ),
        },
      ]
    : [
        LocalStorageService.getRoles() !== "ROLE_MODERATOR"
          ? {
              title: "GR Id",
              dataIndex: "id",
              key: "id",
              render: (text: any) => <p>{"GR-" + text}</p>,
              defaultSortOrder: "descend",
              sorter: (a: { id: number }, b: { id: number }) => a.id - b.id,
              //render: (text: any) => moment(text).format("D MMM y"),
            }
          : {},
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          render: (text: any) => moment(text).format("D MMM y"),
        },
        {
          title: "Challan No.",
          dataIndex: "challanNo",
          key: "challanNo",
          ...getColumnSearchProps("challanNo"),

          // render: (text: any) => (
          //   //getInstrumentById(id);
          //   <p>{"SKY/ENQ/" + text}</p>
          // ),
        },
        {
          title: "Lorry No.",
          dataIndex: "lorryNo",
          key: "lorryNo",
          ...getColumnSearchProps("lorryNo"),

          // render: (text: any) => (
          //   //getInstrumentById(id);
          //   <p>{"SKY/ENQ/" + text}</p>
          // ),
        },
        {
          title: "GR No.",
          dataIndex: "grNumber",
          key: "grNumber",
          ...getColumnSearchProps("grNumber"),

          //     render: (id: any) => {
          //         getInstrumentById(id);

          //     }
        },
        {
          title: "No. Of Pkgs",
          dataIndex: "quantity",
          key: "quantity",
        },
        {
          title: "Weight",
          dataIndex: "weight",
          key: "weight",
        },
        {
          title: "Contains",
          dataIndex: "content",
          key: "content",
          ...getColumnSearchProps("content"),
        },
        {
          title: "Paid Amount",
          dataIndex: "paidAmount",
          key: "paidAmount",
        },
        {
          title: "To Pay Amount",
          dataIndex: "toPayAmount",
          key: "toPayAmount",
        },
        {
          title: "Private Mark",
          dataIndex: "privateMark",
          key: "privateMark",
          ...getColumnSearchProps("privateMark"),
        },
        {
          title: "Status",
          dataIndex: "grStatus",
          key: "grStatus",
          render: (text: any) =>
            text === "Intransit" ? (
              <Tag color="#f50">{text}</Tag>
            ) : text === "At Warehouse" ? (
              <Tag color="#F502e9">
                {text}
                {/* <h1>{text}</h1> */}
              </Tag>
            ) : text === "Partial Dispatch" ? (
              <Tag color="#e6b800">{text}</Tag>
            ) : (
              <Tag color="#004d00">
                {text}
                {/* <h1>{text}</h1> */}
              </Tag>
            ),
        },
        LocalStorageService.getRoles() === "ROLE_ADMIN"
          ? {
              title: "Action",
              dataIndex: "id",
              key: "id",

              render: (id: any) => (
                <Space size={10}>
                  <Popconfirm
                    title="Delete GR?"
                    onConfirm={() => {
                      DeleteGrMutation.mutateAsync(id)
                        .then(({ payload }) => {
                          console.log(payload);

                          message.success(payload.message);
                        })
                        .catch((e: any) => {
                          message.error(e.message);
                        });
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Space>
              ),
            }
          : {},
      ];

  return isMobile ? (
    <Table
      columns={column}
      dataSource={response?.Gr[0]}
      size={"small"}
      //sortDirections={["descend"]}
      scroll={{ x: "100vw", y: "55vh" }}
    />
  ) : (
    <Table
      columns={column}
      dataSource={response?.Gr[0]}
      size={"small"}
      //sortDirections={["descend"]}
      //scroll={{ x: "100vw", y: "55vh" }}
    />
  );
};

export default GrList;
